import Collapse from './Collapse';
import CollapseItem from './CollapseItem';

export {
  Collapse, CollapseItem,
};



// WEBPACK FOOTER //
// ./src/components/collapse/index.js